module.exports = __webpack_public_path__ + "static/media/wirtualnemedia.20781c24.svg";